import React, { useContext, useEffect, useMemo } from 'react';
import { AuthenticationProvider } from '@paycor/pacl';
import { CacheApiClient } from '../../apiClient';
import { RuntimeContext } from '../../common/RuntimeContext';
import { AuthService } from '../../common/interfaces/AuthService';
import { AuthenticatedUserContext } from '../../common/AuthenticatedUser';

export default function CacheHeartbeat(props: any) {
    const { heartbeatInterval } = props;

    const config = useContext(RuntimeContext);
    const authUserContext = useContext(AuthenticatedUserContext);
    const authService: AuthService = useContext(AuthenticationProvider.Context);
    const [cacheApiClient] = useMemo(
        () => [new CacheApiClient(authService, config.app.ui.urlBase)],
        [authService, config.app.ui.urlBase]
    );

    useEffect(() => {
        const getCacheStatus = () => {
            cacheApiClient
                .getCacheStatus()
                .then()
                .catch((error) => {
                    console.error(error);
                });
        };

        if (authUserContext.admin) {
            getCacheStatus(); // warm the cache ASAP
            const interval = setInterval(() => {
                getCacheStatus();
            }, heartbeatInterval);
            return () => {
                clearInterval(interval);
            };
        }
    }, [cacheApiClient, heartbeatInterval, authUserContext.admin]);

    return <></>;
}
